import { render } from "./JudicialMetricReport.vue?vue&type=template&id=a8e25830&ts=true"
import script from "./JudicialMetricReport.vue?vue&type=script&lang=ts"
export * from "./JudicialMetricReport.vue?vue&type=script&lang=ts"

import "./JudicialMetricReport.vue?vue&type=style&index=0&id=a8e25830&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__